import { BooksParameterizationComponent } from './../modules/accounting/books-parameterization/books-parameterization.component';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';

import 'd3';
import 'nvd3';
import './services/extensions';

import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './directive/accordion';
import { ToggleFullscreenDirective } from './directive/toggle-fullscreen.directive';
import { CardRefreshDirective } from './directive/card/card-refresh.directive';
import { CardToggleDirective } from './directive/card/card-toggle.directive';
import { CardComponent } from './directive/card/card.component';
import { NgbModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ParentRemoveDirective } from './directive/parent-remove.directive';
import { SqueezeBoxModule } from 'squeezebox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalAnimationComponent } from './components/modal-animation/modal-animation.component';
import { ModalBasicComponent } from './components/modal-basic/modal-basic.component';
import { ToastyModule } from 'ng2-toasty';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { TagInputModule } from 'ngx-chips';
import { AnimatorModule } from 'css-animator';
import { ColorPickerModule } from 'ngx-color-picker';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { SelectModule } from 'ng-select';
import { SelectOptionService } from './services/select-option.service';
import { FormWizardModule } from 'angular2-wizard';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { QuillEditorModule } from 'ngx-quill-editor';
import { DataFilterPipe } from './pipes/data-filter.pipe';
import { DataTableModule } from 'angular2-datatable';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { FileUploadModule } from 'ng2-file-upload';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { AgmCoreModule } from '@agm/core';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { NgxEchartsModule } from 'ngx-echarts';
import { UiSwitchModule } from 'ng2-ui-switch/dist';
import { ChartModule } from 'angular2-chartjs';
import { KnobModule } from 'ng2-knob';
import { NvD3Module } from 'ng2-nvd3';
import { ClickOutsideModule } from 'ng-click-outside';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NotificationsService } from 'angular2-notifications';
import { ChartistModule } from 'ng-chartist';
import { MenuService } from './services/menu.service';
import { FormControlErrorComponent } from './components/form-control-error/form-control-error.component';
import { HelperService } from './services/helper.service';
import { LocalStorageService } from './services/loca-storage.service';
import { StorageServiceModule } from 'ngx-webstorage-service';
import { AlertService } from './services/alert.service';
import { SliderComponent } from './components/slider/slider.component';
import { PanelsWellsComponent } from './components/panels-wells/panels-wells.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PdfViewerModule } from "ng2-pdf-viewer";
import { MatFormFieldModule, MatInputModule, MatIconModule, MatToolbarModule, MatButtonModule, MatSidenavModule, MatStepperModule, MatListModule, MatNativeDateModule, MatTableModule } from '@angular/material';
import { GeneralService } from './services/general.service';
import { SoapRequestService } from './services/soap/soap-request.service';
import { PasswordDirective } from './directive/app-password/password.directive';
import { DataFilterFormControlPipe } from './pipes/data-filter-form-control.pipe';
import { ModalProcessComponent } from './components/modal-process/modal-process.component';
import { DateFormatService } from './date/date-format.service';
import { ReportThirdpartyInfoComponent } from '../modules/magnetic-media/report-thirdparty-info/report-thirdparty-info.component';
import { CreatePdfService } from './services/create-pdf.service';
import { ExportService } from '../core/services/export/export.service';
import { DataFilterFormControlIgnoreCasePipe } from'./pipes/data-filter-form-controli-ignore-case.pipe';
import { DataTableComponent } from './components/data-table/data-table.component';
import { AccountingnavService } from '../core/services/accounting/accountingnav.service';




const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule.forRoot(),
    SqueezeBoxModule,
    ToastyModule.forRoot(),
    SimpleNotificationsModule.forRoot(),
    TagInputModule,
    UiSwitchModule,
    AnimatorModule,
    ColorPickerModule,
    SelectModule,
    CurrencyMaskModule,
    FormWizardModule,
    NgxDatatableModule,
    DataTableModule,
    QuillEditorModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    FileUploadModule,
    ScrollToModule.forRoot(),
    AgmCoreModule.forRoot({ apiKey: 'AIzaSyCE0nvTeHBsiQIrbpMVTe489_O5mwyqofk' }),
    Ng2GoogleChartsModule,
    NgxEchartsModule,
    ChartModule,
    KnobModule,
    NvD3Module,
    ClickOutsideModule,
    PerfectScrollbarModule,
    ChartistModule,
    StorageServiceModule,
    NgxSpinnerModule,
    PdfViewerModule
  ],
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    CardRefreshDirective,
    CardToggleDirective,
    ParentRemoveDirective,
    CardComponent,
    SpinnerComponent,
    ModalAnimationComponent,
    ModalBasicComponent,
    DataFilterPipe,
    FormControlErrorComponent,
    SliderComponent,
    PanelsWellsComponent,
    PanelsWellsComponent,
    PasswordDirective,
    DataFilterFormControlPipe,
    ModalProcessComponent,
    ReportThirdpartyInfoComponent,
    BooksParameterizationComponent,
    DataFilterFormControlIgnoreCasePipe,
    DataTableComponent
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    CardRefreshDirective,
    CardToggleDirective,
    ParentRemoveDirective,
    PasswordDirective,
    CardComponent,
    SpinnerComponent,
    SqueezeBoxModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    ModalBasicComponent,
    ModalAnimationComponent,
    ToastyModule,
    SimpleNotificationsModule,
    TagInputModule,
    UiSwitchModule,
    AnimatorModule,
    ColorPickerModule,
    SelectModule,
    CurrencyMaskModule,
    FormWizardModule,
    NgxDatatableModule,
    DataTableModule,
    DataFilterPipe,
    QuillEditorModule,
    FroalaEditorModule,
    FroalaViewModule,
    FileUploadModule,
    ScrollToModule,
    AgmCoreModule,
    Ng2GoogleChartsModule,
    NgxEchartsModule,
    ChartModule,
    KnobModule,
    NvD3Module,
    ClickOutsideModule,
    PerfectScrollbarModule,
    ChartistModule,
    FormControlErrorComponent,
    SliderComponent,
    PanelsWellsComponent,
    NgxSpinnerModule,
    PdfViewerModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatStepperModule,
    MatInputModule,
    MatFormFieldModule,
    DataFilterFormControlPipe,
    MatNativeDateModule,
    MatTableModule,
    ModalProcessComponent,
    ReportThirdpartyInfoComponent,
    BooksParameterizationComponent,
    DataFilterFormControlIgnoreCasePipe,
    DataTableComponent
  ],
  providers: [
    MenuService,
    SelectOptionService,
    NotificationsService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    HelperService,
    LocalStorageService,
    AlertService,
    GeneralService,
    SoapRequestService,
    {
      provide: NgbDateParserFormatter,
      useClass: DateFormatService
    },
    CreatePdfService,
    ExportService,
    AccountingnavService,


  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts